<script>
// import isEqual from 'lodash/isEqual';
import ComponentApi from '../mobile-general-form-api';
// import { $http } from '../component-base/xhr';
import { component } from './props';
export default {
    name: component,
    extends: ComponentApi,
    computed: {
        infoKey() {
            if (!this.config.props.infoKey) {
                return '';
            }
            return typeof this.config.props.infoKey === 'number' ? this.config.props.infoKey : this.config.props.infoKey.id;
        },
    },
    methods: {
        async beforeSend(data) {
            data.payload = {
                infoIdList: [this.infoKey],
                reqParams: {
                    ...data.payload,
                },
            };
            return await this.send(data);
        },
        afterSend(data) {
            if (!data) {
                return data;
            }
            const infoKey = this.infoKey;
            const findItem = data.find(item => item.infoId === infoKey);
            return findItem && findItem.value;
        },
    },
};
</script>
